import * as types from "./mutation-type";

export default {
    [types.SET_EMPLOYEES](state, payload) {
        state.employees = payload;
    },
    [types.SET_EMPLOYEE](state, payload) {
        state.employee = payload;
    },
};
